import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';
import { isPresent } from '@ember/utils';
import { isNumber } from 'donor-elf-web/lib/string-utils';
import dateUtils from 'donor-elf-web/lib/date-utils';
import numberUtils from 'donor-elf-web/lib/number-utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import { pledgeOneTimeFrequency } from 'donor-elf-web/lib/pledge-utils';

export default {
  startDate: validatePresence({
    presence: true,
    message: "Start Date can't be blank",
  }),
  contactId: validatePresence({
    presence: true,
    message: "Contact can't be blank",
  }),
  frequency: validatePresence({
    presence: true,
    message: "Frequency can't be blank",
  }),
  amount: validateNumber(),
  endDate: (key, newValue, oldValue, changes, content) => {
    if (isPresent(newValue)) {
      let startDate = assignSingleProperty(content, changes, 'startDate');
      if (isPresent(startDate)) {
        let endDateString = dateUtils.serializeToDateOnly(newValue);
        let startDateString = dateUtils.serializeToDateOnly(startDate);
        if (startDateString > endDateString) {
          return "End Date can't be before Start Date";
        }
      }
    }
    return true;
  },
  // endDateMonths: validateNumber({ gt: 0, integer: true, allowBlank: false, message: 'Must be a positive whole number'})
  endDateMonths: (key, newValue, oldValue, changes, content) => {
    let frequency = assignSingleProperty(content, changes, 'frequency');
    if (frequency === pledgeOneTimeFrequency) {
      if (
        !isNumber(newValue) ||
        !numberUtils.isInteger(Number(newValue)) ||
        Number(newValue) <= 0
      ) {
        return 'Must be a positive whole number';
      }
    }
    return true;
  },
};
